















































import { Vue, Component, Watch } from 'vue-property-decorator';
import BaseContainer from '@/components/BaseContainer.vue';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { formRules } from '@/common/util/validator';
import ButtonPanel from '@/components/ButtonPanel.vue';
import { Notification, DataDictionary } from '@/http';
import { enums } from '@/common/enums';
import DescribePanel from '@/components/DescribePanel.vue';
@Component({
    components: { BaseContainer, ButtonPanel, PageDescribe, DescribePanel },
})
export default class NotificationsEdit extends Vue {
    public $refs: {
        form: HTMLFormElement;
        PWEdit: HTMLFormElement;
        DescribePanel: HTMLFormElement;
    };
    public content: any;
    public form = {
        id: '',
        title: '',
        type: '',
        typeValue: null,
        range: '',
        content: '',
        status: null,
    };
    // 验证规则
    public formRules = formRules;
    public loading: boolean = false;
    public releaseRangeEnum = enums.releaseRangeEnum;
    public notificationTypeList = [];
    public pageTitle: any = '';
    public contant: string = '';
    public id: any = '';

    mounted() {
        this.pageTitle = this.$route.query.pageTitle;
        switch (this.pageTitle) {
            case '新增通知公告':
                this.contant = '支持用户新增通知公告,填写标题、公告类型、发布范围以及公告内容等信息';
                this.GetNotificationTypeList();
                this.reset();
                break;
            case '编辑通知公告':
                this.contant = '支持用户编辑通知公告,填写标题、公告类型、发布范围以及公告内容等信息';
                this.id = this.$route.query.id;
                this.GetNotificationTypeList().then(() => {
                    this.loadDetail();
                });

                break;
            default:
                break;
        }
    }
    public reset() {
        this.form = {
            id: '',
            title: '',
            type: '',
            typeValue: null,
            range: '',
            content: '',
            status: null,
        };
    }
    /**
     * 获取公告类型
     */
    public async GetNotificationTypeList() {
        await DataDictionary.GetDicDetailList({ typeName: '公告类型' }).then((res) => {
            this.notificationTypeList = res;
        });
    }
    public isSubmit: boolean = true; //发布按钮显隐
    public async loadDetail() {
        this.loading = true;
        await Notification.GetNotificationDetail(this.id)
            .then((res) => {
                if (res) {
                    this.form = res;
                    if (this.$refs.DescribePanel) {
                        this.$refs.DescribePanel.setData(this.form.content);
                    }
                    if (this.form.status == 2) {
                        this.isSubmit = false;
                    }
                    this.notificationTypeList.forEach((e) => {
                        if (this.form.type == e.name) {
                            this.form.typeValue = e.value;
                        }
                    });
                    this.loading = false;
                } else {
                    this.loading = false;
                }
            })
            .catch((err) => {
                this.loading = false;
            });
    }
    /**
     * 选择公告类型
     */
    public notificationChange(value) {
        this.notificationTypeList.forEach((e) => {
            if (value == e.value) {
                this.form.type = e.name;
                this.$forceUpdate();
            }
        });
    }
    /**
     * 富文本内容
     */
    dataChange(data) {
        let field = this.$refs['form'].fields;
        field.map((i) => {
            if (i.prop === 'content') {
                i.resetField();
                return false;
            }
        });
        this.form.content = data;
    }
    /**
     * 新增/编辑
     */
    public save() {
        this.loading = true;
        if (this.pageTitle == '新增通知公告') {
            this.form.status = 1;
            this.$refs.form.validate((valid) => {
                if (valid) {
                    Notification.AddNotification({ ...this.form })
                        .then((res) => {
                            this.$message.success('新增成功!');
                            this.loading = false;
                            this.$router.push('/notifications');
                        })
                        .catch((err) => {
                            this.loading = false;
                        });
                } else {
                    this.loading = false;
                }
            });
        } else {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    Notification.EditNotification(this.id, { ...this.form })
                        .then((res) => {
                            this.$message.success('编辑成功!');
                            this.loading = false;
                            this.$router.push('/notifications');
                        })
                        .catch((err) => {
                            this.loading = false;
                        });
                } else {
                    this.loading = false;
                }
            });
        }
    }
    /**
     * 发布公告
     */
    public submit() {
        this.loading = true;
        this.form.status = 2;
        if (this.pageTitle == '新增通知公告') {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    Notification.AddNotification({ ...this.form })
                        .then((res) => {
                            this.$message.success('发布成功!');
                            this.loading = false;
                            this.$router.push('/notifications');
                        })
                        .catch((err) => {
                            this.loading = false;
                        });
                } else {
                    this.loading = false;
                }
            });
        } else {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    Notification.EditNotification(this.id, { ...this.form })
                        .then((res) => {
                            this.$message.success('发布成功!');
                            this.loading = false;
                            this.$router.push('/notifications');
                        })
                        .catch((err) => {
                            this.loading = false;
                        });
                } else {
                    this.loading = false;
                }
            });
        }
    }
    back() {
        this.$router.push('/notifications');
    }
}
